import React from 'react';
import styles from './JobOfferLayout.module.scss';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { date } from '../../../utils/format';
import moment from 'moment';
import mockLogo from './logo-epicode.png';
import mockLogoEmplo from './logo-emplo.png';
import LanguageSwitcher from '../LanguageSwitcher';

const GOOGLE_MAPS_LINK = 'https://www.google.com/maps/search/?api=1&query=';

const JobOfferLayoutHeader = (props: React.PropsWithChildren<{}>) => (
    <div className={styles.header}>
        <div className={classNames(styles.headerContainer)}>{props.children}</div>
    </div>
);

const JobOfferLayoutHeaderLeft = (props: React.PropsWithChildren<{}>) => (
    <div className={styles.headerLeft}>{props.children}</div>
);

const JobOfferLayoutHeaderRight = (props: React.PropsWithChildren<{}>) => (
    <div className={styles.headerRight}>{props.children}</div>
);

const getRemainingDays = (toDate: string): number => {
    const now = moment();
    const deadline = moment(toDate);
    return deadline.diff(now, 'days');
};

interface HeaderProps {
    applyLink?: string;
    jobTitle: string;
    locationDescription: string;
    locationLatitude: number;
    locationLongitude: number;
    createDate: string;
    deadline: string;
}

export default (props: HeaderProps) => {
    const { t } = useTranslation();
    const locationMapLink = `${GOOGLE_MAPS_LINK}${props.locationLatitude.toPrecision(
        8
    )},${props.locationLongitude.toPrecision(8)}`;

    const jobTitleLowercase = props.jobTitle.toLowerCase().trim();
    const isForEpicode =  jobTitleLowercase.includes('php') || jobTitleLowercase.includes('unity');

    return (
        <JobOfferLayoutHeader>
            <JobOfferLayoutHeaderLeft>
                {isForEpicode 
                    ? <img className={classNames(styles.logo)} src={mockLogo} />
                    : <img className={classNames(styles.logo)} src={mockLogoEmplo} />
                }
            </JobOfferLayoutHeaderLeft>
            <div className='flex-fill'>
                <h1 className='font-weight-bold mt-0'>{props.jobTitle}</h1>
                <div>
                    <i className='fa fa-fw fa-briefcase mr-2' />
                    {isForEpicode ? 'Epicode': 'emplo'} Sp. z o.o.
                </div>
                <div className={classNames('mb-2', styles.headerTextMedium)}>
                    <i className='fa fa-fw fa-map-marker mr-2' />
                    {props.locationDescription}{' '}
                    <a className='text-navy' href={locationMapLink} target='_blank' rel='noopener noreferrer'>
                        {t('jobOffer.seeOnMap')}
                    </a>
                </div>
                <div className={styles.headerTextSmall}>
                    <span>
                        {t('jobOffer.published')}: {date(props.createDate)}
                    </span>
                    <span className='ml-3'>
                        {t('jobOffer.availableFor')}: {t('jobOffer.days', { days: getRemainingDays(props.deadline) })} (
                        {date(props.deadline)})
                    </span>
                </div>
            </div>
            <JobOfferLayoutHeaderRight>
                <LanguageSwitcher />

                {props.applyLink && (
                    <Link
                        to={props.applyLink}
                        className={classNames('btn btn-primary btn-lg font-weight-bold', styles.btnApply)}>
                        {t('jobOffer.apply')}
                    </Link>
                )}
            </JobOfferLayoutHeaderRight>
        </JobOfferLayoutHeader>
    );
};
